import { IonBackButton, IonButton, IonButtons } from '@ionic/react';
import { Trans, t } from '@lingui/macro';
import React, { useCallback } from 'react';

import { useCustomRouter } from '../../utils/hooks/useCustomRouter';
import Page from './Page';

type InterventionPageProps = {
    title: string;
    children: React.ReactNode;
    withPadding?: boolean;
    hideBackButton?: boolean;
};

const InterventionPage: React.FunctionComponent<InterventionPageProps> = ({
    hideBackButton = false,
    ...props
}) => {
    const router = useCustomRouter();

    const onCancel = useCallback(() => {
        router.push('/', 'back');
    }, [router]);

    return (
        <Page
            {...props}
            ionButtons={
                <>
                    {hideBackButton ? null : (
                        <IonButtons slot="start">
                            <IonBackButton text={t`Back`} />
                        </IonButtons>
                    )}
                    <IonButtons slot="end">
                        <IonButton onClick={onCancel}>
                            <Trans>Cancel</Trans>
                        </IonButton>
                    </IonButtons>
                </>
            }
        >
            {props.children}
        </Page>
    );
};

export default InterventionPage;
